package com.crowpay

import com.lightningkite.EmailAddress
import com.lightningkite.UUID
import com.lightningkite.lightningdb.Condition
import com.lightningkite.lightningdb.Modification
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathAccess
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import com.lightningkite.toEmailAddress
import com.lightningkite.uuid
import kotlinx.datetime.*
import kotlinx.datetime.format.MonthNames
import kotlinx.datetime.format.Padding
import kotlinx.datetime.format.char
import kotlinx.serialization.KSerializer
import kotlinx.serialization.StringFormat
import kotlin.math.abs

object SharedUtils {
    val emailPattern = Regex("^[a-zA-Z0-9-+._]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+[a-zA-Z0-9-]$")
    val phonePattern =
        Regex("""(?:\+\d+ )?\(\d{3}\) \d{3}-\d{4}|(?:\+\d+)?\d{10}|(?:\+\d+-)?\d{3}-\d{3}-\d{4}|(?:\+\d+ )?\d{3} \d{3} \d{4}""")

    val shrug = """¯\_(ツ)_/¯"""
    val shrugImage = "https://1000logos.net/wp-content/uploads/2023/10/Shrug-Kaomoji.png"
    val mockPayment = "Mock Payment"
    val mock = "mock"
    val nullUUID = UUID.parse("00000000-0000-0000-0000-000000000000")
    const val unknownError = "An unknown error occurred."

    fun isRoutingNumberValid(value: String): Boolean {
        if (value.any { !it.isDigit() } || value.length != 9) return false
        var check = 0
        for (index in value.indices step 3) {
            check += value[index].digitToInt() * 3
            check += value[index + 1].digitToInt() * 7
            check += value[index + 2].digitToInt()
        }
        return check != 0 && check % 10 == 0;
    }

    fun formatDollars(long: Long, absolute: Boolean? = null) = "${if (long < 0 && absolute != true) "-" else ""}$${
        abs(long).toString().reversed().chunked(3).reversed().joinToString(",") { it.reversed() }.ifBlank { "0" }
    }"

    fun formatDollars(float: Float, absolute: Boolean? = null) = {
        val sign = if (float < 0 && absolute != true) "-" else ""
        val absStr = abs(float).toString()

        val parts = absStr.split(".")
        val integerPart = parts[0]
        val decimalPart = parts.getOrNull(1)?.take(2)?.padEnd(2, '0') ?: "00"

        val formattedInteger = integerPart
            .reversed()
            .chunked(3)
            .reversed()
            .joinToString(",") { it.reversed() }

        "$sign$$formattedInteger.$decimalPart"
    }

    fun formatUTC(instant: Instant) = instant
        .toLocalDateTime(TimeZone.UTC)
        .format(
            LocalDateTime.Format {
                monthName(MonthNames.ENGLISH_FULL)
                char(' ')
                dayOfMonth()
                char(' ')
                amPmHour(Padding.NONE)
                char(':')
                minute()
                char(' ')
                amPmMarker("AM", "PM")
                chars(" UTC")
            }
        )
}


//
//private val emailRegex = Regex("(?:[a-z0-9!#\$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#\$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])")
//fun String.toEmailAddressOrNull(): EmailAddress? {
//    val fixed = this.trim().lowercase()
//    return if (emailRegex.matches(fixed)) EmailAddress(fixed)
//    else null
//}